<template>
    <sa-page-layout :titolo="titolo" :showmolalloading="showmolalloading" :btnRefreshVisible="true" @refresh="onRefresh">
        <template slot="table-filter">
            <!--<b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="12">
                        <b-input-group size="sm">
                            <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Testo da Cercare"></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Svuota</b-button>
                            </b-input-group-append>

                        </b-input-group>
                    </b-col>
                </b-row>
            </b-form>-->
        </template>
        <template slot="table-header">
            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col cols="6">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col cols="6">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" id="tbl" :filter="filter" stacked="lg" striped hover :items="items" :fields="fields" current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(tipoReferto)="{ item }">
                        <router-link class="sa-edit-link" :to="'/sorveglianzareferti/view/' + item.id">{{ item.tipoReferto }}</router-link>
                    </template>
                </b-table>
            </div>
        </template>
        <template slot="table-footer">
            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col cols="6">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col cols="6">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
    </sa-page-layout>
</template>
<script>
import axios from "axios";
import moment from "moment";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";

export default {
    components: { SaPageLayout },
    computed: {},
    data() {
        return {
            titolo: "Sorveglianza Referti",
            showmolalloading: false,
            pagelink: "/sorveglianzareferti",
            pathResource: "/sorveglianzareferti",
            currentPage: 1,
            perPage: 30,
            filter: "",
            rows: 0,
            /*pathRest: "/inviosms",
            routelink: "/sms",*/
            fields: [
                {
                    label: "Data",
                    key: "dataOra",
                    sortable: true,
                    thStyle: "width: 12rem",
                    formatter: (value) => {
                        return moment(new Date(value)).format("YYYY-MM-DD HH:mm:ss");
                    },
                },
                {
                    label: "Tipo",
                    key: "tipoReferto",
                    sortable: true,
                },
            ],
            items: [],
            data: [],
            filtro: {},
        };
    },
    created: function () {},
    mounted: function () {
        let me = this;
        me.loadData();
    },
    update: function () {
        console.log("Update");
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment(new Date(value)).format("DD-MM-YYYY HH:mm:ss");
            } else {
                return "---";
            }
        },
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.showmolalloading = true;
            axios
                .get(link, { params: { forPage: me.perPage, page: me.currentPage } })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.showmolalloading = false;
                })
                .catch(function (error) {
                    me.showmolalloading = false;
                    me.$bvToast.toast(error.response.data.messaggio, {
                        title: "Sorveglianza Covid Admin",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        onAdd() {
            let me = this;
            me.$router.replace(me.pagelink + "/edit/-1").catch((err) => {
                err;
            });
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onSubmit: function () {
            let me = this;
            me.filter = me.filtro.referto;
            return false;
        },
    },
};
</script>
<style scoped></style>
